import {AnalysisGraphQL} from 'analysis-tool/AnalysisTypes';

import {AnalysisMainViewItem, AnalysisMainViewItemType} from './main-view/MainViewTypes';
import {getAnalysisSidebarItemDatas} from './sidebar/SidebarItemDatas';

/**
 * Return default item for a given analysis
 *
 * The default is the first side bar item if there are sidebar items. Otherwise its `AnalysisMainViewItemType.EMPTY_ANALYSIS`.
 */
export default function getDefaultMainViewItemForAnalysis(analysis: AnalysisGraphQL): AnalysisMainViewItem {
  const sidebarItemDatas = getAnalysisSidebarItemDatas(analysis);
  return sidebarItemDatas.length > 0
    ? sidebarItemDatas[0].mainViewItem
    : {
        type: AnalysisMainViewItemType.EMPTY_ANALYSIS,
      };
}
